import { create } from "zustand";

function normalizeKey(value) {
  return String(value || "").trim();
}

function mergeRecordValue(record, key, value) {
  const normalizedKey = normalizeKey(key);
  if (!normalizedKey) return record;

  return {
    ...record,
    [normalizedKey]: value,
  };
}

function createInitialCampaignAnalysisState() {
  return {
    analysesByKey: {},
    campaignDetailsById: {},
    campaignsById: {},
    summariesByKey: {},
  };
}

const useCampaignAnalysisStore = create((set, get) => ({
  ...createInitialCampaignAnalysisState(),

  getAnalysis(key) {
    return get().analysesByKey[normalizeKey(key)] || null;
  },

  getCampaign(campaignId) {
    return get().campaignsById[normalizeKey(campaignId)] || null;
  },

  getCampaignDetails(campaignId) {
    return get().campaignDetailsById[normalizeKey(campaignId)] || null;
  },

  getSummary(key) {
    return get().summariesByKey[normalizeKey(key)] || null;
  },

  setAnalysis(key, value) {
    set((state) => ({
      analysesByKey: mergeRecordValue(state.analysesByKey, key, value),
    }));
  },

  setCampaign(campaignId, value) {
    set((state) => ({
      campaignsById: mergeRecordValue(state.campaignsById, campaignId, value),
    }));
  },

  setCampaignDetails(campaignId, value) {
    set((state) => ({
      campaignDetailsById: mergeRecordValue(state.campaignDetailsById, campaignId, value),
    }));
  },

  setSummary(key, value) {
    set((state) => ({
      summariesByKey: mergeRecordValue(state.summariesByKey, key, value),
    }));
  },

  resetCampaignAnalysisState() {
    set(createInitialCampaignAnalysisState());
  },
}));

export default useCampaignAnalysisStore;
